// Theme: zen-garden
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'zen-garden',
  name: 'ZEN',
  tagline: 'ZEN',
  description: 'Silencio, espaco mental e radius amplo.',
  category: 'minimal-atmosphere',
  tier: 'common',
  basePrice: 300,
  swatches: ['#1a1a18', '#6b8e6b', '#232321', '#d6d3d1'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
      '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 25%, transparent)'
    },
    shellClasses: 'font-sans theme-zen'
  },
  colorVars: {
    '--accent': '#6b8e6b',
    '--accent-foreground': '#0e120e',
    '--background': '#1a1a18',
    '--border': '#2a2a28',
    '--card': '#232321',
    '--card-border-active': 'rgba(107, 142, 107, 0.35)',
    '--card-completed': '#1f1f1d',
    '--card-foreground': '#d6d3d1',
    '--card-glow': 'rgba(107, 142, 107, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#d6d3d1',
    '--hold-fill': '#6b8e6b',
    '--input': '#2a2a28',
    '--modal-bg': '#1a1a18',
    '--modal-border': '#2a2a28',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#2a2a28',
    '--muted-foreground': '#a8a29e',
    '--nav-active': '#6b8e6b',
    '--nav-bg': '#1a1a18',
    '--popover': '#232321',
    '--popover-foreground': '#d6d3d1',
    '--primary': '#6b8e6b',
    '--primary-foreground': '#0e120e',
    '--ring': '#6b8e6b',
    '--secondary': '#2a2a28',
    '--secondary-foreground': '#d6d3d1',
    '--streak': '#f97316',
    '--success': '#6b8e6b',
    '--success-foreground': '#0e120e',
    '--xp': '#6b8e6b',
    '--xp-bg': '#2a2a28'
  },
  resolvedVars: {
    '--accent': '#6b8e6b',
    '--accent-foreground': '#0e120e',
    '--accent-foreground-hsl': '120 13% 6%',
    '--accent-foreground-oklch': 'from #0e120e l c h',
    '--accent-hsl': '120 14% 49%',
    '--accent-oklch': 'from #6b8e6b l c h',
    '--background': '#1a1a18',
    '--background-hsl': '60 4% 10%',
    '--background-oklch': 'from #1a1a18 l c h',
    '--border': '#2a2a28',
    '--border-hsl': '60 2% 16%',
    '--border-oklch': 'from #2a2a28 l c h',
    '--border-w': '1px',
    '--card': '#232321',
    '--card-border-active': 'rgba(107, 142, 107, 0.35)',
    '--card-completed': '#1f1f1d',
    '--card-completed-hsl': '60 3% 12%',
    '--card-completed-oklch': 'from #1f1f1d l c h',
    '--card-foreground': '#d6d3d1',
    '--card-foreground-hsl': '24 6% 83%',
    '--card-foreground-oklch': 'from #d6d3d1 l c h',
    '--card-glow': 'rgba(107, 142, 107, 0.10)',
    '--card-hsl': '60 3% 13%',
    '--card-oklch': 'from #232321 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#d6d3d1',
    '--foreground-hsl': '24 6% 83%',
    '--foreground-oklch': 'from #d6d3d1 l c h',
    '--hold-fill': '#6b8e6b',
    '--hold-fill-hsl': '120 14% 49%',
    '--hold-fill-oklch': 'from #6b8e6b l c h',
    '--input': '#2a2a28',
    '--input-hsl': '60 2% 16%',
    '--input-oklch': 'from #2a2a28 l c h',
    '--modal-bg': '#1a1a18',
    '--modal-bg-hsl': '60 4% 10%',
    '--modal-bg-oklch': 'from #1a1a18 l c h',
    '--modal-border': '#2a2a28',
    '--modal-border-hsl': '60 2% 16%',
    '--modal-border-oklch': 'from #2a2a28 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#2a2a28',
    '--muted-foreground': '#a8a29e',
    '--muted-foreground-hsl': '24 5% 64%',
    '--muted-foreground-oklch': 'from #a8a29e l c h',
    '--muted-hsl': '60 2% 16%',
    '--muted-oklch': 'from #2a2a28 l c h',
    '--nav-active': '#6b8e6b',
    '--nav-active-hsl': '120 14% 49%',
    '--nav-active-oklch': 'from #6b8e6b l c h',
    '--nav-bg': '#1a1a18',
    '--nav-bg-hsl': '60 4% 10%',
    '--nav-bg-oklch': 'from #1a1a18 l c h',
    '--popover': '#232321',
    '--popover-foreground': '#d6d3d1',
    '--popover-foreground-hsl': '24 6% 83%',
    '--popover-foreground-oklch': 'from #d6d3d1 l c h',
    '--popover-hsl': '60 3% 13%',
    '--popover-oklch': 'from #232321 l c h',
    '--primary': '#6b8e6b',
    '--primary-foreground': '#0e120e',
    '--primary-foreground-hsl': '120 13% 6%',
    '--primary-foreground-oklch': 'from #0e120e l c h',
    '--primary-hsl': '120 14% 49%',
    '--primary-oklch': 'from #6b8e6b l c h',
    '--radius': '14px',
    '--ring': '#6b8e6b',
    '--ring-hsl': '120 14% 49%',
    '--ring-oklch': 'from #6b8e6b l c h',
    '--secondary': '#2a2a28',
    '--secondary-foreground': '#d6d3d1',
    '--secondary-foreground-hsl': '24 6% 83%',
    '--secondary-foreground-oklch': 'from #d6d3d1 l c h',
    '--secondary-hsl': '60 2% 16%',
    '--secondary-oklch': 'from #2a2a28 l c h',
    '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 25%, transparent)',
    '--streak': '#f97316',
    '--streak-hsl': '25 95% 53%',
    '--streak-oklch': 'from #f97316 l c h',
    '--success': '#6b8e6b',
    '--success-foreground': '#0e120e',
    '--success-foreground-hsl': '120 13% 6%',
    '--success-foreground-oklch': 'from #0e120e l c h',
    '--success-hsl': '120 14% 49%',
    '--success-oklch': 'from #6b8e6b l c h',
    '--tint-primary-subtle': 'hsla(120 14% 49% / 0.15)',
    '--xp': '#6b8e6b',
    '--xp-bg': '#2a2a28',
    '--xp-bg-hsl': '60 2% 16%',
    '--xp-bg-oklch': 'from #2a2a28 l c h',
    '--xp-hsl': '120 14% 49%',
    '--xp-oklch': 'from #6b8e6b l c h'
  }
}
